import React, { useState, useEffect } from "react";
import { Box, Container, Typography, Tabs, Tab, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import axios from "axios";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from '@mui/material/Checkbox';
import Swal from 'sweetalert2';

const Authorization = () => {
  const [tabValue, setTabValue] = useState("modules");
  const [modules, setModules] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [rights, setRights] = useState([]);
  const [loadingModules, setLoadingModules] = useState(true);
  const [loadingRoles, setLoadingRoles] = useState(true);
  const [loadingRights, setLoadingRights] = useState(false);
  const [openAddModuleDialog, setOpenAddModuleDialog] = useState(false);
  const [openEditModuleDialog, setOpenEditModuleDialog] = useState(false);
  const [openAddRoleDialog, setOpenAddRoleDialog] = useState(false);
  const [openEditRoleDialog, setOpenEditRoleDialog] = useState(false);
  const [newModule, setNewModule] = useState({ name: "", value: "" });
  const [editModule, setEditModule] = useState(null);
  const [newRole, setNewRole] = useState({ name: "", description: "" });
  const [editRole, setEditRole] = useState(null);
  const [moduleParentId, setModuleParentId] = useState(null);
  const [roleParentId, setRoleParentId] = useState(null);

  const token = localStorage.getItem("Thyra_Token");
  const practiceId = localStorage.getItem("default_practice");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  

  // Fetch modules from API
  const fetchModules = async () => {
    setLoadingModules(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/Module/getModulesList`, { headers });
      setModules(response || []);
    } catch (error) {
      console.error("Error fetching modules:", error);
      setModules([]);
    } finally {
      setLoadingModules(false);
    }
  };

  // Fetch roles from API
  const fetchRoles = async () => {
    setLoadingRoles(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/Module/Roles`, { headers });
      setRoles(response || []);
    } catch (error) {
      console.error("Error fetching roles:", error);
      setRoles([]);
    } finally {
      setLoadingRoles(false);
    }
  };

  // Fetch rights for the selected role
  // const fetchRights = async (roleId) => {
  //   if (!roleId) return;
  //   setLoadingRights(true);
  //   try {
  //     const response = await axios.get(`${process.env.REACT_APP_API_URL}/Rights/getRights?roleId=${roleId}`, { headers });
  //     setRights(response || []);
  //   } catch (error) {
  //     console.error("Error fetching rights:", error);
  //     setRights([]);
  //   } finally {
  //     setLoadingRights(false);
  //   }
  // };
  const fetchRights = async (roleId) => {
    if (!roleId) return;
    setLoadingRights(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/Rights/getRights?roleId=${roleId}`, { headers });
      const transformedRights = response.map((right) => ({
        ...right,
        isChecked: right.isChecked ?? false, 
      }));
      setRights(transformedRights || []);
    } catch (error) {
      console.error("Error fetching rights:", error);
      setRights([]);
    } finally {
      setLoadingRights(false);
    }
  };
  useEffect(() => {
    fetchModules();
    fetchRoles();
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleRoleChange = (event) => {
    const roleId = event.target.value;
    setSelectedRoleId(roleId);
    fetchRights(roleId);
  };

  // Open dialog to add new child module
  const handleOpenAddModuleDialog = (parentId) => {
    setModuleParentId(parentId);
    setNewModule({ name: "", value: "" });
    setOpenAddModuleDialog(true);
  };
  // Open dialog to edit existing module
  const handleOpenEditModuleDialog = (module) => {
    setEditModule(module);
    setOpenEditModuleDialog(true);
  };

  // Handle adding a new module via API
// Handle adding a new module via API
const handleAddModule = async () => {
  const payload = [{
    name: newModule.name,
    value: newModule.value,
    nodesvalues: newModule.value,
    parentId: moduleParentId,
    children: [],
  }];
  setOpenAddModuleDialog(false);
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/Module/AddModules`, payload, { headers });
    if (response) {
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Module added successfully!',
        confirmButtonColor: '#2B7B7E',
        customClass: {
          container: 'swal2-high-zindex', // Custom class for z-index
        },
      }, 300);
    }
    await fetchModules();
   
  } catch (error) {
    
    console.error("Error adding module:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to add module.',
      confirmButtonColor: '#2B7B7E',
      customClass: {
        container: 'swal2-high-zindex', // Custom class for z-index
      },
    }, 300);
  }
};

// Handle updating a module via API
const handleUpdateModule = async () => {
  const payload = [{
    id: editModule.id,
    name: editModule.name,
    value: editModule.value,
    nodesvalues: editModule.value,
    parentId: editModule.parentId,
    children: editModule.children,
  }];
  setOpenEditModuleDialog(false);
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/Module/AddModules`, payload, { headers });
    if (response) {
      setOpenEditModuleDialog(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Module updated successfully!',
        confirmButtonColor: '#2B7B7E',
        customClass: {
          container: 'swal2-high-zindex', // Custom class for z-index
        },
      },300);
    }
    await fetchModules();
   
  } catch (error) {
    console.error("Error updating module:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to update module.',
      confirmButtonColor: '#2B7B7E',
      customClass: {
        container: 'swal2-high-zindex', // Custom class for z-index
      },
    }, 300);
  }
};

  // Handle deleting a module via API (set inactive: true)
  const handleDeleteModule = async () => {
    setOpenEditModuleDialog(false)
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Are you sure?',
      text: 'This will delete the module.',
      showCancelButton: true,
      confirmButtonColor: '#2B7B7E',
      cancelButtonColor: '#D32F2F',
      confirmButtonText: 'Delete',
      customClass: {
        container: 'swal2-high-zindex',
      },
    }, 300);
  
    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/Module/DeleteModules?id=${editModule.id}`,
          '',
          { headers }
        );
        if (response) {
          setOpenEditModuleDialog(false);
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Module deleted successfully!',
            confirmButtonColor: '#2B7B7E',
            customClass: {
              container: 'swal2-high-zindex', // Custom class for z-index
            },
          }, 300);
        }
        await fetchModules();
      
      } catch (error) {
        console.error("Error deleting module:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to delete module.',
          confirmButtonColor: '#2B7B7E',
          customClass: {
            container: 'swal2-high-zindex', // Custom class for z-index
          },
        }, 300);
      }
    }
  };

  // Open dialog to add new child role
  const handleOpenAddRoleDialog = (parentId) => {
    setRoleParentId(parentId);
    setNewRole({ name: "", description: "" });
    setOpenAddRoleDialog(true);
  };

  // Open dialog to edit existing role
  const handleOpenEditRoleDialog = (role) => {
    setEditRole(role);
    setOpenEditRoleDialog(true);
  };

// Handle adding a new role via API
const handleAddRole = async () => {
  const payload = {
    id: 0,
    name: newRole.name,
    description: newRole.description,
    parentId: roleParentId,
    practiceId: practiceId,
  };
  setOpenAddRoleDialog(false)
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/Module/AddRoles`, payload, { headers });
    if (response) {
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Role added successfully!',
        confirmButtonColor: '#2B7B7E',
        customClass: {
          container: 'swal2-high-zindex', // Custom class for z-index
        },
      }, 300);
    }
    await fetchRoles();
    setOpenAddRoleDialog(false);
  } catch (error) {
    console.error("Error adding role:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to add role.',
      confirmButtonColor: '#2B7B7E',
      customClass: {
        container: 'swal2-high-zindex', // Custom class for z-index
      },
    }, 300);
  }
};

const handleUpdateRole = async () => {
  const payload = {
    id: editRole.id,
    name: editRole.name,
    description: editRole.description,
    parentId: editRole.parentId,
    practiceId: practiceId,
  };
  setOpenEditRoleDialog(false)
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/Module/AddRoles`, payload, { headers });
    if (response) {
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Role updated successfully!',
        confirmButtonColor: '#2B7B7E',
        customClass: {
          container: 'swal2-high-zindex', // Custom class for z-index
        },
      }, 300);
    }
    await fetchRoles();
    setOpenEditRoleDialog(false);
  } catch (error) {
    console.error("Error updating role:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to update role.',
      confirmButtonColor: '#2B7B7E',
      customClass: {
        container: 'swal2-high-zindex', // Custom class for z-index
      },
    }, 300);
  }
};

// Handle deleting a role via API (set inactive: true)
const handleDeleteRole = async () => {
  setOpenEditRoleDialog(false)
  const result = await Swal.fire({
    icon: 'warning',
    title: 'Are you sure?',
    text: 'This will mark the role as inactive.',
    showCancelButton: true,
    confirmButtonColor: '#2B7B7E',
    cancelButtonColor: '#D32F2F',
    confirmButtonText: 'Delete',
    customClass: {
      container: 'swal2-high-zindex', // Custom class for z-index
    },
  }, 300);

  if (result.isConfirmed) {
    const payload = {
      id: editRole.id,
      inactive: true,
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/Module/AddRoles`, payload, { headers });
      if (response) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Role deleted successfully!',
          confirmButtonColor: '#2B7B7E',
          customClass: {
            container: 'swal2-high-zindex', // Custom class for z-index
          },
        }, 300);
      }
      await fetchRoles();
      setOpenEditRoleDialog(false);
    } catch (error) {
      console.error("Error deleting role:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to delete role.',
        confirmButtonColor: '#2B7B7E',
        customClass: {
          container: 'swal2-high-zindex', // Custom class for z-index
        },
      }, 300);
    }
  }
};

  // Render tree nodes for Modules tab
  const renderModuleTree = (nodes) => {
    if (!nodes || !Array.isArray(nodes)) return null;
  
    return nodes.map((node) => {
      if (!node || !node.id) return null;
  
      return (
        <TreeItem
          key={node.id}
          itemId={node.id.toString()}
          label={
            <Box sx={{ display: "flex", alignItems: "center", py: 1 }}>
              <Typography sx={{ flexGrow: 1 }}>{node.name || "Unnamed"}</Typography>
              <IconButton
                onClick={(e) => { // Changed from onChange to onClick
                  e.stopPropagation();
                  handleOpenAddModuleDialog(node.id); // Open dialog with node.id as parentId
                }}
                sx={{ color: "#2B7B7E" }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenEditModuleDialog(node);
                }}
                sx={{ color: "#2B7B7E" }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Box>
          }
        >
          {node.children && node.children.length > 0 ? renderModuleTree(node.children) : null}
        </TreeItem>
      );
    });
  };

  // Render tree nodes for Roles tab
  const renderRoleTree = (nodes) => {
    if (!nodes || !Array.isArray(nodes)) return null;

    return nodes.map((node) => {
      if (!node || !node.id) return null;

      return (
        <TreeItem
          key={node.id}
          itemId={node.id.toString()}
          label={
            <Box sx={{ display: "flex", alignItems: "center", py: 1 }}>
              <Typography sx={{ flexGrow: 1 }}>{node.name || "Unnamed"}</Typography>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenAddRoleDialog(node.id);
                }}
                sx={{ color: "#2B7B7E" }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenEditRoleDialog(node);
                }}
                sx={{ color: "#2B7B7E" }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Box>
          }
        >
          {node.children && node.children.length > 0 ? renderRoleTree(node.children) : null}
        </TreeItem>
      );
    });
  };

  // Render tree nodes for Rights tab
  // const renderRightsTree = (nodes) => {
  //   if (!nodes || !Array.isArray(nodes)) return null;

  //   return nodes.map((node) => {
  //     if (!node || !node.id) return null;

  //     return (
  //       <TreeItem
  //         key={node.id}
  //         itemId={node.id.toString()}
  //         label={
  //           <Box sx={{ display: "flex", alignItems: "center", py: 1 }}>
  //             {/* <input
  //               type="checkbox"
  //               checked={node.isChecked || false}
  //               disabled
  //               style={{ marginRight: 8, color: "#2B7B7E" }}
  //             /> */}
  //           <Checkbox
  //               value={node.isChecked || false}
             
               
           
  //             />
  //             <Typography sx={{ flexGrow: 1 }}>{node.moduleName || "Unnamed"}</Typography>
  //           </Box>
  //         }
  //       >
  //         {node.children && node.children.length > 0 ? renderRightsTree(node.children) : null}
  //       </TreeItem>
  //     );
  //   });
  // };
  // Render tree nodes for Rights tab
const renderRightsTree = (nodes) => {
  if (!nodes || !Array.isArray(nodes)) return null;

  return nodes.map((node) => {
    if (!node || !node.id) return null;

    return (
      <TreeItem
        key={node.id}
        itemId={node.id.toString()}
        label={
          <Box sx={{ display: "flex", alignItems: "center", py: 1 }}>
            <Checkbox
              checked={node.isChecked || false} // Reflect the checked state
              onChange={(e) => {
                e.stopPropagation(); // Prevent TreeItem expand/collapse
                handleCheckboxChange(node, e.target.checked);
              }}
              sx={{ color: "#2B7B7E", "&.Mui-checked": { color: "#2B7B7E" } }}
            />
            <Typography sx={{ flexGrow: 1 }}>{node.moduleName || "Unnamed"}</Typography>
          </Box>
        }
      >
        {node.children && node.children.length > 0 ? renderRightsTree(node.children) : null}
      </TreeItem>
    );
  });
};
  const updateRightsRecursively = (nodes, targetId, isChecked) => {
    return nodes.map((node) => {
      if (node.id === targetId) {
        // Update the target node and its children
        return {
          ...node,
          isChecked,
          children: node.children
            ? node.children.map((child) => ({
                ...child,
                isChecked, // Set children to same checked state
                children: child.children
                  ? child.children.map((grandchild) => ({
                      ...grandchild,
                      isChecked, // Recursively update grandchildren
                    }))
                  : [],
              }))
            : [],
        };
      }
      if (node.children) {
        // Recursively check children
        return {
          ...node,
          children: updateRightsRecursively(node.children, targetId, isChecked),
        };
      }
      return node;
    });
  };
  // Handle checkbox change
  const handleCheckboxChange = async (node, isChecked) => {
    console.log(`Checkbox for node ${node.moduleName} is now ${isChecked ? "checked" : "unchecked"}`);
  
    // Update the rights state recursively
    setRights((prevRights) => updateRightsRecursively(prevRights, node.id, isChecked));
    console.log("node value", node.rightId);
    // Prepare payload as an array
    const payload = [
      {
        id: node.rightsId || 0,
        roleId: selectedRoleId,
        moduleId: node.id,
        isUpdated: true,
        isChecked: isChecked,
        practiceId: practiceId, 
        description: "", 
        inActive: false,
      },
    ];
  
    // Make API call to persist the change
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/Rights/AddRights`, payload, { headers });
      if (response) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Rights change successfully!',
          confirmButtonColor: '#2B7B7E',
          customClass: {
            container: 'swal2-high-zindex', 
          },
        });
      }
    } catch (error) {
      console.error("Error updating right:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to change Rights.',
        confirmButtonColor: '#2B7B7E',
        customClass: {
          container: 'swal2-high-zindex', // Custom class for z-index
        },
      });
    }
  };
 // Recursive function to update isChecked for a node and its children


 

  return (
    <Container sx={{ pt: 10, pb: 4, maxWidth: "lg" }}>
      <Box sx={{ maxWidth: "1000px", mx: "auto" }}>
        {/* Header */}
        {/* <Typography
          variant="h6"
          sx={{ fontWeight: "bold", color: "#2B7B7E", mb: 4 }}
        >
          Authorization
        </Typography> */}

        {/* Tabs Section */}
        <TabContext value={tabValue}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "#E0E0E0",
              mb: 4,
              bgcolor: "#F5F7F9",
              borderRadius: "12 alkoxypx",
              p: 1,
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              sx={{
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: "bold",
                  color: "#77A2A7",
                  fontSize: "0.95rem",
                  "&.Mui-selected": {
                    color: "#2B7B7E",
                  },
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#2B7B7E",
                },
              }}
            >
              <Tab label="Rights" value="rights" />
              <Tab label="Roles" value="roles" />
              <Tab label="Modules" value="modules" />
            </Tabs>
          </Box>

          {/* Tab Panels */}
          <Box
            sx={{
              bgcolor: "#FFFFFF",
              p: 4,
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
            }}
          >
            <TabPanel value="rights" sx={{ p: 0 }}>
              {loadingRoles ? (
                <Typography sx={{ color: "#77A2A7" }}>
                  Loading roles...
                </Typography>
              ) : (
                <>
                  <FormControl fullWidth sx={{ mb: 3, maxWidth: 300 }}>
                    <InputLabel id="role-select-label">Select Role</InputLabel>
                    <Select
                      labelId="role-select-label"
                      value={selectedRoleId}
                      label="Select Role"
                      onChange={handleRoleChange}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {roles.map((role) => (
                        <MenuItem key={role.id} value={role.id}>
                          {role.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {selectedRoleId ? (
                    loadingRights ? (
                      <Typography sx={{ color: "#77A2A7" }}>
                        Loading rights...
                      </Typography>
                    ) : rights.length === 0 ? (
                      <Typography sx={{ color: "#77A2A7" }}>
                        No rights available for this role.
                      </Typography>
                    ) : (
                      <SimpleTreeView
                        defaultCollapseIcon={<ExpandMoreIcon />}
                        defaultExpandIcon={<ChevronRightIcon />}
                        sx={{ flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
                      >
                        {renderRightsTree(rights)}
                      </SimpleTreeView>
                    )
                  ) : (
                    <Typography sx={{ color: "#77A2A7" }}>
                      Please select a role to view rights.
                    </Typography>
                  )}
                </>
              )}
            </TabPanel>

            <TabPanel value="roles" sx={{ p: 0 }}>
              {loadingRoles ? (
                <Typography sx={{ color: "#77A2A7" }}>
                  Loading roles...
                </Typography>
              ) : roles.length === 0 ? (
                <Typography sx={{ color: "#77A2A7" }}>
                  No roles available.
                </Typography>
              ) : (
                <>
                  <SimpleTreeView
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                    sx={{ flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
                  >
                    {renderRoleTree(roles)}
                  </SimpleTreeView>
                  <Box mt={2}>
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => handleOpenAddRoleDialog(null)}
                      sx={{ bgcolor: "#2B7B7E", "&:hover": { bgcolor: "#195C5F" } }}
                    >
                      Add Root Role
                    </Button>
                  </Box>
                </>
              )}
            </TabPanel>

            <TabPanel value="modules" sx={{ p: 0 }}>
              {loadingModules ? (
                <Typography sx={{ color: "#77A2A7" }}>
                  Loading modules...
                </Typography>
              ) : modules.length === 0 ? (
                <Typography sx={{ color: "#77A2A7" }}>
                  No modules available.
                </Typography>
              ) : (
                <>
                  <SimpleTreeView
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                    sx={{ flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
                  >
                    {renderModuleTree(modules)}
                  </SimpleTreeView>
                  <Box mt={2}>
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => handleOpenAddModuleDialog(null)}
                      sx={{ bgcolor: "#2B7B7E", "&:hover": { bgcolor: "#195C5F" } }}
                    >
                      Add Root Module
                    </Button>
                  </Box>
                </>
              )}
            </TabPanel>
          </Box>
        </TabContext>
      </Box>

      {/* Add New Module Dialog */}
      <Dialog open={openAddModuleDialog} onClose={() => setOpenAddModuleDialog(false)}>
        <DialogTitle>New Module</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            value={newModule.name}
            onChange={(e) => setNewModule({ ...newModule, name: e.target.value })}
            fullWidth
            sx={{ mt: 2 }}
          />
          <TextField
            label="Value"
            value={newModule.value}
            onChange={(e) => setNewModule({ ...newModule, value: e.target.value })}
            fullWidth
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenAddModuleDialog(false)}
            sx={{ color: "#77A2A7" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddModule}
            sx={{ bgcolor: "#2B7B7E", color: "#FFFFFF", "&:hover": { bgcolor: "#195C5F" } }}
            disabled={!newModule.name || !newModule.value}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Module Dialog */}
      <Dialog open={openEditModuleDialog} onClose={() => setOpenEditModuleDialog(false)}>
        <DialogTitle>Update Module</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            value={editModule?.name || ""}
            onChange={(e) => setEditModule({ ...editModule, name: e.target.value })}
            fullWidth
            sx={{ mt: 2 }}
          />
          <TextField
            label="Value"
            value={editModule?.value || ""}
            onChange={(e) => setEditModule({ ...editModule, value: e.target.value })}
            fullWidth
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenEditModuleDialog(false)}
            sx={{ color: "#77A2A7" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteModule}
            sx={{ color: "#D32F2F" }}
          >
            Delete
          </Button>
          <Button
            onClick={handleUpdateModule}
            sx={{ bgcolor: "#2B7B7E", color: "#FFFFFF", "&:hover": { bgcolor: "#195C5F" } }}
            disabled={!editModule?.name || !editModule?.value}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add New Role Dialog */}
      <Dialog open={openAddRoleDialog} onClose={() => setOpenAddRoleDialog(false)}>
        <DialogTitle>New Role</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            value={newRole.name}
            onChange={(e) => setNewRole({ ...newRole, name: e.target.value })}
            fullWidth
            sx={{ mt: 2 }}
          />
          <TextField
            label="Description"
            value={newRole.description}
            onChange={(e) => setNewRole({ ...newRole, description: e.target.value })}
            fullWidth
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenAddRoleDialog(false)}
            sx={{ color: "#77A2A7" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddRole}
            sx={{ bgcolor: "#2B7B7E", color: "#FFFFFF", "&:hover": { bgcolor: "#195C5F" } }}
            disabled={!newRole.name || !newRole.description}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Role Dialog */}
      <Dialog open={openEditRoleDialog} onClose={() => setOpenEditRoleDialog(false)}>
        <DialogTitle>Update Role</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            value={editRole?.name || ""}
            onChange={(e) => setEditRole({ ...editRole, name: e.target.value })}
            fullWidth
            sx={{ mt: 2 }}
          />
          <TextField
            label="Description"
            value={editRole?.description || ""}
            onChange={(e) => setEditRole({ ...editRole, description: e.target.value })}
            fullWidth
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenEditRoleDialog(false)}
            sx={{ color: "#77A2A7" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteRole}
            sx={{ color: "#D32F2F" }}
          >
            Delete
          </Button>
          <Button
            onClick={handleUpdateRole}
            sx={{ bgcolor: "#2B7B7E", color: "#FFFFFF", "&:hover": { bgcolor: "#195C5F" } }}
            disabled={!editRole?.name || !editRole?.description}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Authorization;